import React from "react";

type Props = {
  children: React.ReactNode;
};

const SubmitButtonRow = ({ children }: Props) => {
  return <div className="flex flex-row justify-end">{children}</div>;
};

export { SubmitButtonRow };
